import { render } from "./NotFound.vue?vue&type=template&id=46149ffe&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=46149ffe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46149ffe"

export default script